import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IdexService } from 'app/idex.service';
import { Mimetype } from 'app/shared/mimetype';
import { OneDriveItem } from '../onedrive-list/onedrive-item.type';

declare let $: any;

@Component({
   selector: 'app-one-drive-folders',
   templateUrl: './one-drive-folders.component.html',
   styleUrls: ['../folders/folders.component.css'],
   animations: [
      trigger('state', [
         state('collapse', style({ height: 0 })),
         state('expand', style({ height: '*' })),
         transition('collapse => expand', animate('400ms ease-in')),
         transition('expand => collapse', animate('400ms ease-out'))
      ])
   ]
})
export class OneDriveFoldersComponent {

   @Input() tin: string;
   @Input() parent = '';
   @Input() path = '';
   @Input() parentPath = '';
   @Input() move = false;
   @Input() exportPath = false;
   @Input() selectFile = false;
   @Input() selectSite = false;
   @Input() select_id: any;
   @Input() drivePath: string;
   @Input() access_token: string;
   @Input() selectedItems: any;
   @Input() typeName: any;
   @Input() sourceItemID: string;

   m = false;
   animationState = 'collapse';
   folders: any[] = [];
   loading = false;
   error: string;
   selectedItem: any;
   selected: boolean;
   givePath: string;
   isSelect: boolean;
   pageSize = 999;

   @Output() selectPath = new EventEmitter<OneDriveItem>();
   @Output() getPath = new EventEmitter<any>();
   @Output() errorHandler = new EventEmitter<any>();

   constructor( private service: IdexService) {
   }

   toggle() {
      this.loading = true;
      if (this.isExpanded()) {
         this.setAnimationState();
         this.loading = false;
      } else {
         if (this.exportPath) {
               this.service.onedriveFolders(this.access_token, this.pageSize, this.drivePath)
               .subscribe(res => {
                  this.folders = res.value;
                  this.setAnimationState();
               }, error => {
                  this.handleError(error);
               }).add(() => {
                  this.loading = false;
               });
         } else {
            this.service.onedriveListItems(this.access_token, this.drivePath, this.pageSize)
               .subscribe(res => {
                  this.folders = res.value;
                  this.setAnimationState();
               }, error => {
                  this.handleError(error);
               }).add(() => {
                  this.loading = false;
               });

         }
      }
   }

    handleError(error: any): void {
      this.errorHandler.emit(error);
    }

   setAnimationState(){
      setTimeout(() => {
         this.animationState = this.animationState === 'collapse' ? 'expand' : 'collapse';
      }, 100);
   }

   isExpanded(): boolean {
      return this.animationState === 'expand';
   }

   getFragment(name: string): string {
      return this.path ? this.path + '/' + name : name;
   }

   select(name: any, sub: any,isFolder: boolean) {
      if (this.isSelect) {
         if(this.exportPath){
            $('.selectedPath').removeClass('selectedPath');
            $('#export_' + this.replaceIdOneDrive(name.id)).addClass('selectedPath');
         }
         if (!sub.isExpanded() && isFolder) {
            sub.toggle();
         }
         if (this.selectedItem === sub) {
            return;
         }
         if (this.selectedItem) {
            this.selectedItem.selected = false;
         }
         this.selectedItem = sub;
         sub.selected = true;
      }
   }

   replaceIdOneDrive(id): String {
      return id.replace( "!","_");
   }

   unselect(): void {
      if(this.exportPath){
         $('.selectedPath').removeClass('selectedPath');
      }
      if (this.selectedItem) {
         this.selectedItem.selected = false;
         this.selectedItem = undefined;
      }
   }

   onSelectPath(agreed: any) {
      if(this.exportPath){
         this.selectPath.emit(agreed);
         this.isSelect = true;
      }else{
         if (agreed.file) {
            this.selectPath.emit(agreed);
            this.isSelect = true;
         } else {
            this.isSelect = false;
         }
      }

   }

   onGetPath(name) {
      if (this.isSelect || this.exportPath) {
         this.getPath.emit(this.parentPath + name);
      }
   }


   expand(folders: any,isFolder: boolean) {
      if (!folders.isExpanded() && isFolder) {
         folders.toggle();
      }
   }

   getIconOneDrive(item: any): string {
      return Mimetype.getIconOneDrive(item);
   }

   oneDriveIgnoreFileType(item: any): boolean {
      if (!item.file) {
         return false
      } else {
         return !Mimetype.validateExtension(item.file.mimeType, this.typeName);
      }
   }

   oneDriveIsFolder(item: any): boolean {
      return Boolean(!item.file)
   }

   selectFiles(event: any, item: any, uploadType: 'zDox' | 'google drive' | 'onedrive') {
      if (item.file) {
         if(Mimetype.validateExtension(item.file.mimeType, this.typeName)){
            this.manageFiles(event,item,uploadType);
         }
      }
   }

   manageFiles(event: any, item: any, uploadType: 'zDox' | 'google drive' | 'onedrive'){
      event.preventDefault();
      item.selected = !item.selected;
      const index = this.selectedItems.indexOf(item);
      if (item.selected) {
         if (index === -1) {
            item.uploadType = uploadType;
            this.selectedItems.push(item);
         }
      } else {
         if (index !== -1) {
            this.selectedItems.splice(index, 1);
         }
      }
   }

   isSameFolder(destinationFolderID: string): boolean {
      return destinationFolderID === this.sourceItemID;
   }
}
